import {BrowserRouter, Route, Routes, useLocation, Navigate} from "react-router-dom";
import React from 'react';
import ReactDOM from 'react-dom/client';
import 'antd/dist/reset.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Tutorial from "./Tutorial";
import Download from "./Download";
import BugReports from "./BugReports";
import Extra from "./Extra";
import References from "./References";


const root = ReactDOM.createRoot(document.getElementById('root'));

const RouterWrapper = ()=>{
    const { pathname } = useLocation();
    return (
        <>
            <Navigate from="/:url*(/+)" to={pathname.replace(/\/+$/, "")} />
            <Routes>
                <Route path="/" element={<App/>} />
                <Route path="/tutorial/" element={<Tutorial/>}/>
                <Route path="/download/" element={<Download />} />
                <Route path="/references/" element={<References />}/>
                <Route path="/bugreports/" element={<BugReports />}/>
                <Route path="/extras/" element={<Extra/>}/>
            </Routes>
        </>
    )
}
root.render(
        <BrowserRouter basename='/phisical/checkup'>
            <RouterWrapper/>
        </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();